(function () {
  const CART_LINK_SELECTOR = '#cart-icon-bubble, a[href="/cart"], a[href$="/cart"]';
  const RETRY_DELAY = 100;
  const MAX_ATTEMPTS = 40;

  const getCartUrl = () => window.routes?.cart_url || '/cart';

  const getSmartCart = () => window.Rebuy?.SmartCart;

  const isCartUrl = (href) => {
    if (!href) return false;

    const linkUrl = new URL(href, window.location.origin);
    const cartUrl = new URL(getCartUrl(), window.location.origin);

    return linkUrl.pathname === cartUrl.pathname || linkUrl.pathname.endsWith('/cart');
  };

  const isModifiedClick = (event) =>
    event.defaultPrevented ||
    event.button !== 0 ||
    event.metaKey ||
    event.ctrlKey ||
    event.shiftKey ||
    event.altKey;

  const refreshRebuyCart = () => {
    const rebuyCart = window.Rebuy?.Cart;

    if (typeof rebuyCart?.fetch === 'function') {
      rebuyCart.fetch();
    }

    if (typeof rebuyCart?.getCart === 'function') {
      rebuyCart.getCart();
    }
  };

  const closeNativeCart = () => {
    const nativeCart = document.querySelector('cart-drawer');

    if (typeof nativeCart?.close === 'function') {
      nativeCart.close();
    }
  };

  const showSmartCart = ({ fallbackToCart = false, delay = 0 } = {}) =>
    new Promise((resolve) => {
      let attempts = 0;

      const tryShow = () => {
        const smartCart = getSmartCart();

        if (typeof smartCart?.show === 'function') {
          try {
            refreshRebuyCart();
            smartCart.show();
            resolve(true);
          } catch (error) {
            console.warn('Unable to open Rebuy Smart Cart.', error);
            resolve(false);
          }
          return;
        }

        attempts += 1;

        if (attempts >= MAX_ATTEMPTS) {
          if (fallbackToCart) {
            window.location.href = getCartUrl();
          }

          resolve(false);
          return;
        }

        window.setTimeout(tryShow, RETRY_DELAY);
      };

      window.setTimeout(tryShow, delay);
    });

  const addNativeCartHidingStyles = () => {
    if (document.getElementById('GeoRebuySmartCartStyles')) return;

    const style = document.createElement('style');
    style.id = 'GeoRebuySmartCartStyles';
    style.textContent = '.smart-cart--enabled cart-drawer,.smart-cart--enabled #CartDrawer{display:none!important;}';
    document.head.appendChild(style);
  };

  const enhanceCartIcon = () => {
    const cartIcon = document.getElementById('cart-icon-bubble');

    if (!cartIcon) return;

    cartIcon.setAttribute('role', 'button');
    cartIcon.setAttribute('aria-haspopup', 'dialog');
  };

  const onCartLinkClick = (event) => {
    if (isModifiedClick(event)) return;

    if (!(event.target instanceof Element)) return;

    const cartLink = event.target.closest(CART_LINK_SELECTOR);

    if (!cartLink || (cartLink.id !== 'cart-icon-bubble' && !isCartUrl(cartLink.getAttribute('href')))) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    closeNativeCart();
    showSmartCart({ fallbackToCart: true });
  };

  const onCartIconKeydown = (event) => {
    if (event.code !== 'Space' && event.code !== 'Enter') return;

    if (!(event.target instanceof Element)) return;

    const cartIcon = event.target.closest('#cart-icon-bubble');

    if (!cartIcon) return;

    event.preventDefault();
    event.stopPropagation();
    closeNativeCart();
    showSmartCart({ fallbackToCart: true });
  };

  window.GeoRebuySmartCart = {
    show: showSmartCart,
    refresh: refreshRebuyCart,
    closeNativeCart,
  };

  addNativeCartHidingStyles();
  document.addEventListener('click', onCartLinkClick, true);
  document.addEventListener('keydown', onCartIconKeydown, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceCartIcon);
  } else {
    enhanceCartIcon();
  }
})();
